export const MAX_LENGTH_OTP = 8;
export const FORM_FIELDS = {
  OTP: 'otp',
};
export const OTP_COUNT_SECOND = 300;

export const MAX_ATTEMPT = 2;
export const MAX_RETRY = 2;
